import { ADMIN_MODAL_ACTIONS } from "../../constants"

export const showAdminModal = (payload) => {
    return {
        type: ADMIN_MODAL_ACTIONS.SHOW_ADMIN_MODAL,
        payload
    }
}

export const hideAdminModal = () => {
    return {
        type: ADMIN_MODAL_ACTIONS.HIDE_ADMIN_MODAL
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/A_Admin_Alert_Modal.js